import { render, staticRenderFns } from "./extrafield-assign.vue?vue&type=template&id=554c8f2b"
import script from "./extrafield-assign.vue?vue&type=script&lang=js"
export * from "./extrafield-assign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports